<template>
  <div class="order">
    <div class="order__number-container">
      <span class="order__number">N° {{ item.code }} |</span>
      <span class="order__date">{{ item.order_date | moment("D/MM/YYYY")}}</span>
    </div>
    <div class="order__products">
      <img src="/static/img/pictos/nombredeproduits.svg">
      <span>Nombre de produits :</span> <span class="bleu" v-if="quantity">{{ quantity }}</span>
    </div>
    <div class="order__products" v-if="item.status >= 3 && item.status < 9">
      <img src="/static/img/pictos/nombredeproduits.svg">
      <span>Quantité commandée :</span> <span class="bleu">{{ getTotalQte }}</span><span v-if="item.status >= 2"> expédée :</span><span v-if="item.status >= 2" class="bleu"> {{ getTotalShippedQuantity }}</span>
    </div>
    <div class="order__products"  v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
      <img src="/static/img/pictos/nombredeproduits.svg">
      <span>Valeur de la commande :</span> <span class="bleu" v-if="total">{{ total }} €</span>
    </div>
    <div class="order__user">
      <img src="/static/img/pictos/commandepar.svg">
      <span>Commandée par :</span> <span class="bleu" v-if="item.created_by_user">{{ item.created_by_user.firstname }} {{ item.created_by_user.lastname }}</span> <span class="pour" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">Pour</span> <span class="bleu" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true && item.created_for_user">{{ item.created_for_user.firstname }} {{ item.created_for_user.lastname }}</span>
    </div>
    <div class="order__bottom">
      <div class="order__status-container">
        <div class="order__status">
          <span>Statut : <strong>{{ $t('order.statuses.'+item.status) }}</strong></span>
        </div>
        <div class="order__completion-container completion">
          <div class="completion__part1" v-if="item.status != 5"></div>
          <div class="completion__part2" v-if="item.status == 4"></div>
          <div class="completion__complete" v-if="item.status == 5"></div>
        </div>
      </div>
      <router-link
        v-if="item.id"
        :to="{name: 'OrderDetail', params: {id:item.id}}"
        class="order__btn-container"
      >
        <span>Voir le détail</span>
        <a class="order__btn">
          <img src="/static/img/pictos/flecheblanche.svg">
        </a>
      </router-link>
    </div>
  </div>
  <!-- <div class="order order--mobile" v-else>


  </div> -->
</template>

<script>
export default {
  name: "Order",
  props: [
    "item",
    "repass"
  ],
  data() {
    return {
    }
  },
  computed: {
    quantity() {
      let quantity = 0;
      if(this.item.lines){
        for(var j = 0; j < this.item.lines.length; j++){
          quantity += this.item.lines[j].quantity;
        }
      }
      return quantity;
    },
    total() {
      let total = 0;
      if(this.item.lines){
        for(var j = 0; j < this.item.lines.length; j++){
          let price = 0;
          for(let y=0; y<this.item.lines[j].product.prices.length; y++){
            if(this.item.lines[j].product.prices[y].entreprise_description == 'MCI'){
              price = this.item.lines[j].product.prices[y].price;
            }
          }
          total += (this.item.lines[j].quantity*price);
        }
      }
      return total.toFixed(2);
    },
    getTotalQte(){
      var quantity = 0;
      this.item.lines.map(item => {
        quantity = quantity + item.quantity;
      });
      return quantity;
    },
    getTotalShippedQuantity(){
      var shippedQuantity = 0;
      this.item.lines.map(item => {
        shippedQuantity = shippedQuantity + item.shipped_quantity
      });
      return shippedQuantity;
    },
    me: function() {
      let me = this.$store.getters["auth/user"];

      if(typeof(me) == 'string'){
        return JSON.parse(me)
      }else{
        return me;
      }
    },
  },
  created(){

  },
  mounted() {

  }
};
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .order{ border-bottom: 1px solid $color1; padding-bottom: 20px; margin-bottom: 20px; position: relative;
    &:last-of-type{ border-bottom: none; }
    &__user{ font-family: 'ClanPro'; font-size: 12px; color: $grisfonce;
      img{ width: 20px; margin-right: 5px; }
      span{
        &.pour{ margin-left: 80px; }
        &.bleu{ color: $color1; }
      }
    }
    &__products{ font-family: 'ClanPro'; font-size: 12px; color: $grisfonce; margin-bottom: 10px;
      img{ width: 20px; margin-right: 5px; }
      span{
        &.bleu{ color: $color1; }
      }
    }
    &__repass{ position: absolute; right: 0; top: 0; display: flex; flex-direction: row; border: 1px solid $grisclair; align-items: center; justify-content: center; padding: 10px 15px;
      span{ color: $vert; font-family: 'ClanProBold'; font-weight: normal; font-size: 12px; margin-right: 50px; }
      img{ width: 30px; }
      &:hover{ text-decoration: none; }
    }
    &__number{ color: $color1; font-family: 'ClanPro'; font-size: 15px; }
    &__date{ color: $color1; font-family: 'ClanProBold'; font-weight: normal; font-size: 15px; }
    &__number-container{ margin-bottom: 10px; }
    &__bottom{ display: flex;
    }
    &__btn{ background-color: $color2; width: 110px; display: flex; height: 50px; align-items: center; justify-content: center;
      img{ width: 20px; }
    }
    &__btn-container{ width: 110px; text-align: center;
      span{ color: $color2; font-family: 'ClanProBold'; font-size: 12px; }
      &:hover{ text-decoration: none; }
    }
    &__status-container{ flex: 1; justify-content: flex-end; display: flex; flex-direction: column; margin-right: 10px; }
    .completion{ background-color: $grisclair; height: 7px; width: 100%; border-radius: 3px; display: flex;
      &__part1{ width: 50%; background-color: $color2; height: 100%; border-top-right-radius: 3px; border-bottom-right-radius: 3px; }
      &__part2{ width: 50%; background-color: $vert; height: 100%; height: 100%; border-top-right-radius: 3px; border-bottom-right-radius: 3px; }
      &__complete{ width: 100%; background-color: $vertfonce; }
      &__refused{ width: 100%; background-color: $rouge; }
    }
    &--detail{
      .order__bottom{ margin-top: 20px; }
      .order__btn-container{ display: none; }
    }
    &--mobile{
      .order__repass{ padding: 10px;
        span{ margin-right: 20px; }
      }
      .order__bottom{ padding: 0 10px; }
      .order__number-container, .order__products, .order__user{ margin-left: 20px; margin-right: 20px; }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Order/Order.vue